var $3ab64b73ea27c23a$exports = {};
$3ab64b73ea27c23a$exports = {
  "Clear search": "Not\u012Br\u012Bt mekl\u0113\u0161anu"
};
export { $3ab64b73ea27c23a$exports as default };